import { __read } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Card } from '@tencent/tea-component/lib/card';
import { Form } from '@tencent/tea-component/lib/form';
import { Alert } from '@tencent/tea-component/lib/alert';
export function BuyFeeCard(_a) {
    var className = _a.className, style = _a.style, children = _a.children, _b = _a.position, position = _b === void 0 ? 'bottom' : _b, title = _a.title, _c = _a.collapsed, collapsed = _c === void 0 ? true : _c, _d = _a.alertContent, alertContent = _d === void 0 ? '' : _d;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _e = __read(useState(collapsed), 2), collapsed_ = _e[0], setCollapsed = _e[1];
    useEffect(function () {
        setCollapsed(collapsed);
    }, [collapsed]);
    var buyFeeCardBottom = useRef(null);
    var _f = __read(useState(true), 2), browserSupportPositionSticky = _f[0], setBrowserSupportPositionSticky = _f[1];
    useEffect(function () {
        if (buyFeeCardBottom.current !== null && getComputedStyle(buyFeeCardBottom.current).position === 'sticky') {
            // do nothing
        }
        else {
            setBrowserSupportPositionSticky(false);
        }
    }, [buyFeeCardBottom]);
    if (position === 'right') {
        return (React.createElement(Card, { className: classNames('buy-fee-card', className), style: style },
            React.createElement(Card.Body, { title: title }, children)));
    }
    return (React.createElement("div", { ref: buyFeeCardBottom, className: classNames('buy-fee-card__bottom', className), style: {
            position: browserSupportPositionSticky ? 'sticky' : 'relative',
        } },
        React.createElement("div", { className: classNames('buy-fee-card__bottom-container', {
                'buy-fee-card__bottom__expand': !collapsed_,
                'buy-fee-card__bottom__collapse': collapsed_,
            }), style: {
                position: browserSupportPositionSticky ? 'absolute' : 'relative',
            } },
            alertContent && (React.createElement(Alert, { type: "error" },
                React.createElement("div", { className: "buy-alert-container" },
                    React.createElement("p", { className: "buy-alert-content" }, alertContent)))),
            React.createElement(Form, null,
                React.createElement("div", { className: "buy-fee-form-group" }, children)))));
}
export function BuyFeeCardLeft(props) {
    return React.createElement("div", { className: classNames('buy-fee-form-group__left', props.className) }, props.children);
}
export function BuyFeeCardRight(_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "buy-fee-form-group__right" }, React.Children.toArray(children)
        .filter(function (child) { return React.isValidElement(child); })
        .map(function (child) {
        var _a, _b, _c, _d;
        /** 是否只有单行内容 */
        var isSingleLine = ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'FormItem' && React.isValidElement((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.children);
        return React.cloneElement(child, isSingleLine
            ? {
                className: ((_d = (_c = child.props) === null || _c === void 0 ? void 0 : _c.className) !== null && _d !== void 0 ? _d : '') + " buy-fee-form__text",
            }
            : {});
    })));
}
//# sourceMappingURL=BuyFeeCard.js.map